import React, { FC } from 'react';
import { SelectField } from '@payfit/midnight/dist/SelectField';
import { textTitle3 } from '../../styles/typography';
import { classNames } from '../../utils/style';

export interface HeadingProps {
  title: string;
  subheadings?: Array<{ title: string }>;
}

export interface MinifiedTableOfContentProps {
  title?: string | undefined;
  onChange?: (value: string) => void;
  options: Array<{ label: string; value: string }>;
  valueSelected: string;
  className?: string;
}

export const MinifiedTableOfContent: FC<MinifiedTableOfContentProps> = ({
  title,
  options,
  valueSelected,
  onChange,
  className,
}) => {
  return (
    <section
      className={classNames('MinifiedTableOfContent py-24 lg:py-0', className)}
    >
      {title && <div className={classNames('pb-8', textTitle3)}>{title}</div>}
      <SelectField
        hideLabel
        label={title ?? ''}
        options={options}
        onChange={onChange}
        value={valueSelected}
      />
    </section>
  );
};
